var _defs, _line, _line2, _line3, _path, _polygon, _path2, _path3, _path4, _path5, _rect, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.17,
    y1: 126.78,
    x2: 186.75,
    y2: 126.78
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.17,
    y1: 159.07,
    x2: 101.75,
    y2: 159.07
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.17,
    y1: 191.36,
    x2: 101.75,
    y2: 191.36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.23,238H60.69a15.27,15.27,0,0,1-15.23-15.23V67.9L102,18h93.26a15.27,15.27,0,0,1,15.23,15.23V174"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "101.97 18 101.73 67.82 45.46 67.9 101.97 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.43,90.31V76.78c0-7.45-6-10.2-12.94-10.2L161.58,76,153,66.58c-6.94,0-12.33,2.75-12.33,10.2V90.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.22,48.47a9.65,9.65,0,1,1-19.3,0V44.84a9.65,9.65,0,1,1,19.3,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.29,173.84V160.25a4.85,4.85,0,0,1,4.82-4.87H175.4a4.85,4.85,0,0,1,4.82,4.87v13.59Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.54,184c0,11.87-18.07,20-40.16,20H159.13C137,204,119,195.89,119,184V174h91.57Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 118.97,
    y: 173.89,
    width: 91.57,
    height: 63.95
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 158.79,
    y1: 192.14,
    x2: 170.71,
    y2: 192.14
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployment);
export default __webpack_public_path__ + "static/media/employment.60d75de4a5d635ba13e201a4fb3661b5.svg";
export { ForwardRef as ReactComponent };